import React from 'react';
import { Box, ButtonBase, Typography, alpha } from '@mui/material';
import { ISidebarItemProps } from '../../Interfaces/sidebar.interface';

export const JobOpeningSidebarItem = ({
  button,
  isActive,
  onSelect,
}: ISidebarItemProps) => {
  const { value, label, Icon } = button;

  return (
    <ButtonBase
      onClick={() => onSelect(value)}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'row', lg: 'column' },
        alignItems: 'center',
        gap: { xs: 0.75, lg: 0 },
        px: { xs: 0.5, lg: 0 },
        py: 0,
        borderRadius: '8px',
        minWidth: { xs: 'fit-content', lg: 0 },
        width: { xs: 'auto', lg: '100%' },
        transition: 'all 0.2s ease-in-out',
        cursor: 'pointer',
        textAlign: 'center',
        '&:hover .sidebar-icon-box': {
          borderColor: isActive ? 'primary.main' : (theme) => alpha(theme.palette.primary.main, 0.4),
          color: isActive ? '#ffffff' : 'primary.main',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        },
        '&:hover .sidebar-label': {
          color: 'primary.main',
        },
      }}
    >
      <Box
        className='sidebar-icon-box'
        sx={{
          width: { xs: 28, lg: 36 },
          height: { xs: 28, lg: 36 },
          borderRadius: { xs: '8px', lg: '12px' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          border: '1px solid',
          borderColor: isActive ? 'primary.main' : '#e2e8f0',
          bgcolor: isActive ? 'primary.main' : '#ffffff',
          color: isActive ? '#ffffff' : '#94a3b8',
          boxShadow: isActive
            ? (theme) => `0 10px 15px -3px ${alpha(theme.palette.primary.main, 0.25)}`
            : '0 1px 2px rgba(0, 0, 0, 0.04)',
          transform: isActive ? { xs: 'none', lg: 'scale(1.05)' } : 'scale(1)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '& .sidebar-icon': {
            width: { xs: 14, lg: 16 },
            height: { xs: 14, lg: 16 },
            color: 'inherit',
          },
        }}
      >
        <Icon className='sidebar-icon' />
      </Box>

      <Typography
        variant='caption'
        className='sidebar-label'
        sx={{
          fontSize: { xs: '9px', lg: '7.5px' },
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '-0.025em',
          lineHeight: 1.15,
          color: isActive ? 'primary.main' : '#94a3b8',
          textAlign: { xs: 'left', lg: 'center' },
          transition: 'color 0.2s ease-in-out',
          mt: { xs: 0, lg: '4px' },
          width: { xs: 'auto', lg: '100%' },
          maxWidth: { xs: 120, lg: 52 },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {label}
      </Typography>
    </ButtonBase>
  );
};
